module.exports = __webpack_public_path__ + "static/images/1fd66dff35e8fd10b64b326e4c82b86f.svg";